const clone = require('lodash/clone');

const env = require('../helpers/env.js');
const filterIceServers = require('./filterIceServers.js');
const logging = require('../ot/logging.js');
const OTPlugin = require('../otplugin/otplugin.js');

module.exports = function createPeerConnection({
  window,
  config: originalConfig,
  constraints,
  webRTCStream,
  completion: originalCompletion,
}) {
  logging.debug('createPeerConnection: called');

  const config = clone(originalConfig);

  const completion = (err, ...args) => {
    if (err) {
      logging.error('createPeerConnection: failure:', err);
    } else {
      logging.debug('createPeerConnection: success');
    }

    originalCompletion(err, ...args);
  };

  if (OTPlugin.isInstalled()) {
    OTPlugin.initPeerConnection(config, constraints, webRTCStream, completion);
    return;
  }

  config.iceServers = filterIceServers(env.name, config.iceServers);

  const pc = new window.RTCPeerConnection(config, constraints);

  completion(null, pc);
};



// WEBPACK FOOTER //
// ./src/js/helpers/create_peer_connection.js